import React from "react";
import Dialog from "@mui/material/Dialog";
import useStore from "store/hook";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import checkmail from "assets/images/authenticationImages/checkmail.png";
import { Link } from "react-router-dom";

const Checkmail = ({ submit, loading, setEmail }) => {
  const { store, setDialogue } = useStore();

  const {
    app: {
      dialogs: {
        openCheckmail: { isOpen, action, email },
      },
    },
  } = store;

  const handleClose = () => {
    setDialogue({
      type: "openCheckmail",
      isOpen: false,
      action: "",
      email: "",
    });
    setEmail("");
  };

  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "25px",
            m: {
              xs: 1,
              sm: 1,
              md: 2,
            },
          },
        }}
      >
        <SoftBox
          width="100%"
          sx={{ backgroundColor: "white.main" }}
          display="flex"
          flexDirection="column"
        >
          <SoftBox
            sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
            borderRadius="xxl"
            width="100%"
          ></SoftBox>

          <SoftBox display="flex" flexDirection="column" sx={{ p: { xs: 1, sm: 2, md: 4 } }}>
            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftBox
                height="250px"
                width="250px"
                sx={{
                  backgroundImage: `url(${checkmail})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                }}
              />
            </SoftBox>

            <SoftBox
              display="flex"
              sx={{
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                width: "100%",
                flexGrow: 1,
              }}
            >
              <SoftBox
                display="flex"
                sx={{ py: 1, flexDirection: "column", gap: 2, width: "100%" }}
              >
                <SoftBox
                  width="100%"
                  display="flex"
                  sx={{
                    alignItems: "start",
                    justifyContent: "start",
                    flexDirection: "column",
                    gap: 1.5,
                  }}
                >
                  <SoftBox sx={{ textAlign: "start" }}>
                    <SoftTypography fontWeight="medium" sx={{ fontSize: 24, color: "black.main" }}>
                      Check Your Mail
                    </SoftTypography>
                  </SoftBox>

                  <SoftBox>
                    <SoftBox sx={{ textAlign: "start" }}>
                      <SoftTypography
                        sx={{
                          fontSize: 14,
                          color: "lightblack.main",
                          display: { xs: "inline", lg: "block" },
                        }}
                      >
                        We’ve sent a password reset link to your registered email address. Please
                        check your inbox and follow the instructions to create a new password.
                      </SoftTypography>
                    </SoftBox>

                    <SoftBox sx={{ textAlign: "start" }}>
                      <SoftTypography
                        fontWeight="medium"
                        sx={{
                          fontSize: 14,
                          color: "lightblack.main",
                          display: { xs: "inline", lg: "block" },
                        }}
                      >
                        Additional Notes:
                      </SoftTypography>

                      <SoftBox>
                        <List>
                          <ListItem>
                            <ListItemIcon sx={{ minWidth: 20 }}>
                              <CircleIcon
                                sx={{
                                  width: 8,
                                  height: 8,
                                  color: "lightblack.main",
                                  fontWeight: "normal",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary="It may take a few minutes for the email to arrive."
                              primaryTypographyProps={{
                                fontSize: 14,
                                fontWeight: "normal",
                                color: "lightblack.main",
                              }}
                            />
                          </ListItem>

                          <ListItem>
                            <ListItemIcon sx={{ minWidth: 20 }}>
                              <CircleIcon
                                sx={{
                                  width: 8,
                                  height: 8,
                                  color: "lightblack.main",
                                  fontWeight: "normal",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary="Don’t forget to check your spam or junk folder."
                              primaryTypographyProps={{
                                fontSize: 14,
                                fontWeight: "normal",
                                color: "lightblack.main",
                              }}
                            />
                          </ListItem>
                        </List>
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            <SoftBox
              display="flex"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                flexDirection: {
                  xs: "column",
                  sm: "row",
                  md: "row",
                },
                gap: 2,
                pt: 4,
              }}
            >
              <SoftButton
                color="lightblack"
                variant="outlined"
                disabled={loading}
                onClick={submit}
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
              >
                {loading ? "Loading..." : "Resend Mail"}
              </SoftButton>
              <SoftButton
                component={Link}
                to= "/authentication/sign-in"
                variant="contained"
                color="primary"
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
              >
                Go to Login
              </SoftButton>
            </SoftBox>
          </SoftBox>

          <SoftBox
            sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main", mt: "auto" }}
            borderRadius="xxl"
            width="100%"
          ></SoftBox>
        </SoftBox>
      </Dialog>
    </React.Fragment>
  );
};

export default Checkmail;
